// src/components/shared/LocationPermissionModal.js
// Guide de réactivation de la géolocalisation, adapté à l'appareil - NE PAS MODIFIER

import React from 'react';
import { useTheme } from '../../hooks/useTheme';

const detectPlatform = () => {
  const ua = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  const isAndroid = /Android/.test(ua);
  if (isIOS) return 'ios';
  if (isAndroid) return 'android';
  return 'desktop';
};

const LocationPermissionModal = ({ open, onClose }) => {
  const { theme } = useTheme();

  if (!open) return null;

  const platform = detectPlatform();

  const instructions = {
    ios: [
      "Ouvrez l'app Réglages de votre téléphone",
      "Confidentialité et sécurité → Service de localisation → vérifiez qu'il est activé",
      "Faites défiler jusqu'à votre navigateur (Safari, Chrome...) et autorisez-le",
      "Revenez sur Fynho et réessayez",
    ],
    android: [
      "Appuyez sur l'icône ⓘ ou 🔒 à côté de l'adresse du site",
      "Ouvrez « Autorisations » ou « Paramètres du site »",
      "Activez « Position »",
      "Revenez sur Fynho et réessayez",
    ],
    desktop: [
      "Cliquez sur l'icône 🔒 ou ⓘ à gauche de l'adresse du site",
      "Trouvez « Position » dans les autorisations",
      "Changez-la sur « Autoriser »",
      "Rechargez la page et réessayez",
    ],
  };

  const steps = instructions[platform];

  const styles = {
    backdrop: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      zIndex: 2000,
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
    },
    sheet: {
      width: '100%',
      maxWidth: '480px',
      backgroundColor: theme.bgCard,
      borderTopLeftRadius: '20px',
      borderTopRightRadius: '20px',
      padding: '12px 20px calc(24px + env(safe-area-inset-bottom, 0px))',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      borderTop: `1px solid ${theme.border}`,
    },
    handle: {
      width: '40px',
      height: '4px',
      borderRadius: '2px',
      backgroundColor: theme.textMuted,
      margin: '4px auto 4px',
    },
    icon: { fontSize: '36px', textAlign: 'center' },
    title: {
      fontSize: '17px',
      fontWeight: '700',
      color: theme.textPrimary,
      textAlign: 'center',
    },
    subtitle: {
      fontSize: '13px',
      color: theme.textSecondary,
      textAlign: 'center',
      lineHeight: '1.5',
    },
    stepsList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
    },
    step: {
      display: 'flex',
      gap: '10px',
      alignItems: 'flex-start',
      fontSize: '14px',
      color: theme.textPrimary,
      lineHeight: '1.4',
    },
    stepNumber: {
      width: '22px',
      height: '22px',
      borderRadius: '50%',
      backgroundColor: theme.goldSoft,
      color: theme.gold,
      fontSize: '12px',
      fontWeight: '700',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    closeButton: {
      padding: '14px',
      backgroundColor: theme.gold,
      border: 'none',
      borderRadius: '10px',
      color: theme.mode === 'light' ? '#FFFFFF' : '#0A0E1A',
      fontSize: '15px',
      fontWeight: '700',
      cursor: 'pointer',
      marginTop: '4px',
    },
  };

  return (
    <div style={styles.backdrop} onClick={onClose}>
      <div style={styles.sheet} onClick={(e) => e.stopPropagation()}>
        <div style={styles.handle} />
        <div style={styles.icon}>📍</div>
        <div style={styles.title}>Localisation désactivée</div>
        <div style={styles.subtitle}>
          Pour trouver les annonces près de vous, autorisez l'accès à votre position en suivant ces étapes :
        </div>

        <div style={styles.stepsList}>
          {steps.map((step, index) => (
            <div key={index} style={styles.step}>
              <span style={styles.stepNumber}>{index + 1}</span>
              <span>{step}</span>
            </div>
          ))}
        </div>

        <button style={styles.closeButton} onClick={onClose}>
          J'ai compris
        </button>
      </div>
    </div>
  );
};

export default LocationPermissionModal;